import { LayerFeatureStyle } from '@datum-group/datum-map/lib/Layer/StyleUtils/resources';
import { CreateStyleSettings } from '@project/components/Module/Cartograms';

export const FEATURE_FILL_COLOR_DEFAULT = { a: 1, b: 255, g: 255, r: 255 };
export const FEATURE_BORDER_COLOR_DEFAULT = { a: 1, b: 0, g: 0, r: 0 };

// TODO: создать гибкий инструмент для создания стилей, вынести его из картограмм
export const createStyles = ({
  polygonColor,
  text,
}: CreateStyleSettings = {}): LayerFeatureStyle => ({
  polygon: {
    border: {
      color: FEATURE_BORDER_COLOR_DEFAULT,
      lineCap: 'round',
      lineJoin: 'round',
      width: 1,
    },
    fill: {
      color: polygonColor ?? FEATURE_FILL_COLOR_DEFAULT,
    },
  },
  text: {
    fill: '#000',
    font: '10px sans-serif',
    offsetX: 0,
    offsetY: 0,
    overflow: false,
    text,
    textAlign: 'center',
    textBaseline: 'alphabetic',
  },
});
